/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { IRFuncao } from '../../../shared/services/api/rh/Relatorios/RelatoriosService';
 

async function RFuncao(dados: IRFuncao[], fazenda: string, texto: string){
  
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const Quantidade = dados.length;
  const rows = dados.map((row) => {
    return [
      {text: row.nome, alignment: 'left',  fontSize: 10},
      {text: row.funcao, alignment: 'left',  fontSize: 8},
      {text: row.cargo, alignment: 'left',  fontSize: 8},
    ]; 
  });  

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';   
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas'); 
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement; 
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl =  process.env.REACT_APP_URL_IMGLOG || ''; 
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }

  const documentDefinition : any = {
    pageSize: 'A4',
    pageMargins: [10, 30, 30, 10],
    header: '',
    content: ([
      {   
        table: {
          body: [
            [ 
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],  
                table: {
                  widths: [500],
                  body: [
                    [ 
                      {text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16,  margin: [0, 5, 0, 0], bold: true, color: '#FFFFFF',  alignment: 'center', fillColor: '#00A47B', border: [false, false, false, false]},
                    ],
                    [ 
                      {text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true]},
                    ],
                  ]
                }
              },
              
            ],
            [
              {text: 'Relatório de Cargo por Fazenda', colSpan: 2, margin: [5, 10, 0, 0], fontSize: 18, bold: true,  alignment: 'center',  border: [false, false, false, false]},
              {}
            ]
          ]
        }
      },
      {text: 'Fazenda: ' + fazenda, alignment: 'center',  fontSize: 13},
      {text: texto, fontSize: 14},
      {  
        table:{
          widths: [250, 180, 150],
          headerRows: 1,
          body: [
            [
              {text: 'Nome',  style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 10},
              {text: 'Cargo', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 10},
              {text: 'Função', style: 'tableHeader',  alignment: 'center', fillColor: '#dddddd', fontSize: 10},
            ],
            ...rows,
            [
              {text: 'Quantidade de Colaboradores: '+new Intl.NumberFormat('pt-br', {minimumFractionDigits: 0}).format(Quantidade), alignment: 'left',  fontSize: 10, bold: true, border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
            ]
          ]
        }, 
      },
      
    ]),
      
  };
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.open();
}
export default RFuncao;

